export * from './NewsModuleCard';
